/* ============================================================
   NUOTIE Theme — assets/theme.js
   原生 JS（无 jQuery/框架），defer 加载。
   模块：移动菜单 / Hero 轮播 / Tab 切换 / 图库切换 / 变体联动 /
   AJAX 迷你购物车 / 客户端筛选（不写 URL）/ 邮件弹窗 /
   Shopify 编辑器事件（shopify:section:load 等）。
   约束：事件委托 + 小任务，无长任务（INP）；退出时清理。
   ============================================================ */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Money helper ----------
     符号与代码来自 layout/theme.liquid 注入的 window.NT_CURRENCY（= cart.currency，
     即用户当前选择的展示货币，随所在市场 / 货币选择器变化）。
     这里只输出「符号 + 金额」；货币代码由页面上的 span.money-code 单独承担，
     同一处不会出现两份货币文案。
     旧写法把非 USD/EUR/GBP 拼成 "SGD 89.90"，而首屏是服务端渲染的 "$89.90"，
     切换变体时价格格式会跳变，多货币市场下尤其明显。 */
  var NT_CUR = window.NT_CURRENCY || {};
  var CART_CURRENCY = NT_CUR.code
    || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
    || 'USD';
  var CART_CURRENCY_SYMBOL = NT_CUR.symbol || '';
  /* 字母或句点结尾的符号（CHF、kr、Rs.）后面要留空格，与后台货币格式
     "CHF {{amount}}" 对齐；$ € £ ¥ 这类纯符号紧贴金额。缺了这个空格，
     服务端渲染是 "CHF 51.00"、切变体后 JS 输出 "CHF51.00"，同页格式会跳变。 */
  var NT_SYMBOL_NEEDS_SPACE = /[A-Za-z.]$/.test(CART_CURRENCY_SYMBOL);
  /* 千分位：服务端 money 过滤器输出 "$29.90" / "¥4,900"，JS 若输出 "29.9" / "¥4900"，
     切变体时同一位置会跳格式。这里固定两位小数后再裁掉 ".00"：
       29.90 → "29.90"（保留，与 USD 服务端一致）
       4900  → "4,900.00" → "4,900"（与零小数货币的服务端一致）
     注意必须给 minimumFractionDigits: 2，只写 maximumFractionDigits 会把 29.90
     输出成 "29.9"，是比原来更差的结果。 */
  function formatMoney(cents) {
    var amount = (cents / 100)
      .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      .replace(/\.00$/, '');
    if (CART_CURRENCY_SYMBOL) return CART_CURRENCY_SYMBOL + (NT_SYMBOL_NEEDS_SPACE ? ' ' : '') + amount;
    return CART_CURRENCY + ' ' + amount;
  }

  /* ---------- 移动菜单 ---------- */
  function initMenu(root) {
    var btn = $('[data-menu-toggle]', root);
    var nav = $('[data-mobile-nav]', root);
    if (!btn || !nav || btn.dataset.bound) return;
    btn.dataset.bound = '1';
    btn.addEventListener('click', function () {
      var open = nav.hasAttribute('hidden');
      if (open) { nav.removeAttribute('hidden'); } else { nav.setAttribute('hidden', ''); }
      btn.setAttribute('aria-expanded', String(open));
    });
  }

  /* ---------- Hero 轮播（自动播放 + 手动）：无人工干预时按设定秒数自动切换；
       按住左右拖动/滑动、圆点点击为人工干预 —— 干预期间暂停，结束后自动恢复；
       点击（非拖动）进入该帧链接。 ---------- */
  function initHero(root) {
    var section = $('[data-hero]', root);
    if (!section || section.dataset.bound) return;
    section.dataset.bound = '1';
    var slides = $$('[data-hero-slide]', section);
    var dots = $$('[data-hero-dot]', section);
    var multi = slides.length > 1;
    var index = 0;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
    }

    /* --- 自动播放：section 上的 data-hero-autoplay 为间隔毫秒数，0 / 缺省 = 不自动 --- */
    var speed = parseInt(section.getAttribute('data-hero-autoplay'), 10);
    if (isNaN(speed) || speed <= 0) speed = 0;
    /* 尊重系统「减少动态效果」：开启时不做自动轮播（手动切换仍可用） */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) speed = 0;
    var timer = null;
    var hovering = false;
    var keyboardUser = false; /* 只有键盘操作过才在聚焦时暂停，见下方 focusin */

    function stopTimer() { if (timer) { clearInterval(timer); timer = null; } }
    function startTimer() {
      if (!multi || speed <= 0 || hovering || dragging || document.hidden) return;
      stopTimer();
      timer = setInterval(function () { show(index + 1); }, speed);
    }
    function restartTimer() { stopTimer(); startTimer(); }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopTimer(); else startTimer();
    });

    var startX = 0, startY = 0, dragging = false, moved = false, justDragged = false;
    var THRESHOLD = 40; /* 横向位移超过该像素才翻页，轻触不误判 */

    function onMove(e) {
      if (!dragging) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      if (!moved && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) moved = true;
      if (moved && e.cancelable) e.preventDefault(); /* 拖图时避免选中文本/触发原生拖拽 */
    }

    function onUp(e) {
      if (!dragging) return;
      dragging = false;
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerup', onUp);
      document.removeEventListener('pointercancel', onUp);
      var dx = e.clientX - startX;
      if (moved && Math.abs(dx) >= THRESHOLD) {
        show(dx < 0 ? index + 1 : index - 1);
        justDragged = true; /* 本次拖动结束后抑制紧随的那次 click */
      }
      startTimer(); /* 拖动结束，恢复自动播放 */
    }

    function onDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      moved = false;
      justDragged = false;
      keyboardUser = false; /* 说明这次是鼠标/触摸操作，点击带来的聚焦不应触发暂停 */
      startX = e.clientX;
      startY = e.clientY;
      stopTimer(); /* 人工干预开始，暂停自动播放 */
      document.addEventListener('pointermove', onMove);
      document.addEventListener('pointerup', onUp);
      document.addEventListener('pointercancel', onUp);
    }

    if (multi) {
      section.classList.add('hero--draggable');
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          stopTimer();
          show(parseInt(d.dataset.slideIndex, 10));
          restartTimer();
        });
      });
      section.addEventListener('pointerdown', onDown);
      section.addEventListener('dragstart', function (e) { e.preventDefault(); });
      /* 鼠标悬停时暂停（仅鼠标：触摸设备 tap 也会触发 pointerenter，
         不区分会误判成悬停而永久停播） */
      section.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'mouse') { hovering = true; stopTimer(); }
      });
      section.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'mouse') { hovering = false; startTimer(); }
      });
      /* 键盘用户 Tab 聚焦到轮播时暂停（避免自动切换打断操作）。
         仅对键盘生效：Chrome 鼠标/触摸点击也会给按钮聚焦，
         若不加判定，点一次圆点就会让自动播放看起来「坏了」。 */
      document.addEventListener('keydown', function () { keyboardUser = true; });
      section.addEventListener('focusin', function () {
        if (keyboardUser) { hovering = true; stopTimer(); }
      });
      section.addEventListener('focusout', function () {
        if (keyboardUser) { hovering = false; startTimer(); }
      });
      startTimer();
    }

    /* 点击进入链接：① 拖动后这一次点击作废；② 点按钮/圆点等交互元素不接管；
       ③ 其余位置（含整图）跳转该帧 Button link —— 有按钮文字的帧同样生效。 */
    section.addEventListener('click', function (e) {
      if (justDragged) {
        justDragged = false;
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      var t = e.target;
      if (!t || !t.closest || t.closest('a, button')) return;
      var slide = t.closest('[data-hero-slide]');
      var link = slide && slide.getAttribute('data-hero-link');
      if (link) window.location.href = link;
    }, true);
  }

  /* ---------- 商品 Tab 切换（内容全部已 SSR，仅显隐） ---------- */
  function initTabs(root) {
    var section = $('[data-tabs]', root);
    if (!section || section.dataset.bound) return;
    section.dataset.bound = '1';
    var toggles = $$('[data-tab-toggle]', section);
    var panels = $$('[data-tab-panel]', section);
    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        toggles.forEach(function (x) {
          var active = x === t;
          x.classList.toggle('is-active', active);
          x.setAttribute('aria-selected', String(active));
        });
        panels.forEach(function (p) { p.classList.toggle('hidden', p.dataset.tabId !== t.dataset.tabId); });
      });
    });
  }

  /* ---------- 产品图库切换（缩略图与主图帧 data-slide-index 一一对应） ---------- */
  function initGallery(root) {
    var gallery = $('[data-gallery]', root);
    if (!gallery || gallery.dataset.bound) return;
    gallery.dataset.bound = '1';
    var thumbs = $$('[data-gallery-thumb]', gallery);
    var slides = $$('[data-gallery-slide]', gallery);
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.dataset.slideIndex, 10);
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });
  }

  /* ---------- 变体联动：价格 / 库存 / 图片 / 加购按钮 ---------- */
  function initVariantPicker(root) {
    var wrap = $('[data-product-container]', root);
    if (!wrap || wrap.dataset.variantBound) return;
    wrap.dataset.variantBound = '1';
    var selects = $$('[data-variant-select]', wrap);
    var jsonEl = $('[data-variant-json]', wrap);
    if (!selects.length || !jsonEl) return;
    var variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    function currentSelection() {
      return selects.map(function (s) { return s.value; });
    }
    function findVariant() {
      var sel = currentSelection();
      return variants.find(function (v) {
        return sel.every(function (val, i) { return v.options[i] === val; });
      });
    }
    /* 文件名归一化：去查询串/路径 + 去 Shopify 尺寸后缀（_800x / _800x800 / _800x800_crop_center） */
    function baseFileName(url) {
      return (url || '').split('?')[0].split('/').pop().replace(/_\d+x[0-9]*(_[a-z_]+)*/i, '');
    }
    /* 变体主图联动：
       SKU 图现在就排在主图列表（最前），因此按「变体主图文件名」匹配定位帧即可；
       命中后切换激活帧并同步底部缩略图高亮（缩略图与帧序号一一对应）。 */
    function showVariantImage(v) {
      if (!v.featured_image) return;
      var key = baseFileName(v.featured_image.src);
      if (!key) return;
      var slides = $$('[data-gallery-slide]', wrap);
      var thumbs = $$('[data-gallery-thumb]', wrap);
      var idx = -1;
      for (var i = 0; i < slides.length; i++) {
        var im = slides[i].querySelector('img');
        if (im && baseFileName(im.src) === key) { idx = i; break; }
      }
      if (idx === -1) return;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', Number(t.dataset.slideIndex) === idx); });
    }
    selects.forEach(function (s) {
      s.addEventListener('change', function () {
        var v = findVariant();
        if (!v) return;
        var idInput = $('[data-variant-id]', wrap);
        if (idInput) idInput.value = v.id;
        /* 价格服务端渲染为初始值，变体切换后由 JS 更新（初始值 SEO 可抓取） */
        var priceEl = $('[data-price]', wrap);
        var compareEl = $('[data-compare-price]', wrap);
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = formatMoney(v.compare_at_price);
            compareEl.hidden = false;
          } else { compareEl.hidden = true; }
        }
        var stockEl = $('[data-stock-status]', wrap);
        if (stockEl && typeof v.available === 'boolean') {
          /* 文案与服务端 SSR 的分支保持一致（"In stock" / "Sold out"）。
             变体 JSON 不含 inventory_quantity，JS 拿不到真实数量，所以这里只能
             输出不含数量的通用文案；别再加 "✓" 之类服务端没有的前缀，否则切换
             变体时同一行会突然多出一个符号。 */
          stockEl.textContent = v.available ? 'In stock' : 'Sold out';
          stockEl.classList.toggle('product__stock--in', v.available);
          stockEl.classList.toggle('product__stock--out', !v.available);
        }
        /* SKU 同步：变体 JSON 自带 sku 字段，无需额外请求。
           该变体没填 SKU 时整行隐藏，避免残留上一个变体的编号；
           产品内所有变体都没 SKU 时，这一行服务端根本不会渲染，此处取不到元素即跳过。 */
        var skuRow = $('[data-sku-row]', wrap);
        var skuEl = $('[data-sku]', wrap);
        if (skuEl) {
          var skuVal = v.sku || '';
          skuEl.textContent = skuVal;
          if (skuRow) skuRow.hidden = !skuVal;
        }
        var addBtn = $('[data-add-to-cart]', wrap);
        if (addBtn) { addBtn.disabled = !v.available; addBtn.classList.toggle('btn--disabled', !v.available); }
        /* 变体主图联动（图片全部已 SSR，仅切换激活帧） */
        showVariantImage(v);
      });
    });

    /* ---------- 缩略图选择（variant-picker 双轨的 JS 轨） ----------
       点击缩略图 → 写入对应隐藏 select 并派发 change，
       价格/库存/加购/主图联动全部复用上方既有 change 处理器。
       选中态（is-active）不由 change 事件链单独承担：点击后立刻重刷一次，
       避免移动端任何一处链路中断导致「没有选中提示」。
       select 自身变化（如历史回退）时反向同步缩略图选中态。 */
    var swatches = $$('[data-swatch]', wrap);
    function syncSwatches() {
      swatches.forEach(function (b) {
        var sel = selects[Number(b.dataset.optionIndex)];
        if (!sel) return;
        var on = sel.value === b.dataset.value;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    swatches.forEach(function (b) {
      b.addEventListener('click', function () {
        var sel = selects[Number(b.dataset.optionIndex)];
        if (!sel) return;
        if (sel.value !== b.dataset.value) {
          sel.value = b.dataset.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        /* 无论值是否发生变化都重刷高亮：移动端 tap 不触发 hover，
           选中提示必须由 is-active 单独保证。 */
        syncSwatches();
      });
    });
    selects.forEach(function (s) {
      s.addEventListener('change', syncSwatches);
    });
    /* 初始对齐：以 select 的实际值为准重刷一遍高亮（服务端渲染态的双保险） */
    syncSwatches();
  }

  /* ---------- AJAX 迷你购物车 ---------- */
  function refreshCartDrawer() {
    /* sections API 拉最新抽屉 HTML：cache:no-store 防止命中加购前的缓存快照
       （否则抽屉会显示过期内容）；当前 URL 已带查询参数时用 & 拼接；
       拉取失败静默保留旧内容，不阻塞后续打开动作。 */
    var url = window.location.pathname
      + (window.location.search ? window.location.search + '&sections=cart-drawer' : '?sections=cart-drawer');
    return fetch(url, { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cart-drawer]');
        var current = $('[data-cart-drawer]');
        if (fresh && current) { current.innerHTML = fresh.innerHTML; }
      })
      .catch(function () { /* 拉取失败：保留现有抽屉内容 */ });
  }
  function updateCartCount(itemCount) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = itemCount;
      el.classList.toggle('hidden', !itemCount);
    });
  }
  function openCart() {
    var drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    drawer.removeAttribute('hidden');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    /* 面板 touch-action: pan-y —— 纵向滚动保持原生，横向拖动交给关闭手势（见 initCart） */
    var panel = drawer.querySelector('.cart-drawer__panel');
    if (panel) panel.style.touchAction = 'pan-y';
  }
  function closeCart() {
    var drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    drawer.setAttribute('hidden', '');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  var cartDelegated = false;
  function initCart() {
    /* document 级监听只注册一次，关闭/打开全部走事件委托：
       refreshCartDrawer 会整体替换抽屉 innerHTML，X 按钮 / 遮罩每次都是全新元素，
       绑定在元素上的监听器随旧元素一起销毁（此前「点 X 无法关闭」的根因），
       委托到 document 后无论重渲染多少次都持续有效。 */
    if (cartDelegated) return;
    cartDelegated = true;
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-cart-toggle]');
      if (toggle) { e.preventDefault(); openCart(); return; }
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); return; }
      if (e.target.closest('[data-cart-overlay]')) closeCart();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

    /* 按住向右拖动 / 滑动关闭（Pointer 事件，鼠标与触屏通用）：
       仅在面板内、横向意图明确（dx>10 且 |dx|>|dy|）时接管，面板内纵向滚动不受影响；
       松手时横向位移超过 80px 视为关闭，否则回弹复位。 */
    var swipe = null;
    document.addEventListener('pointerdown', function (e) {
      var drawer = $('[data-cart-drawer]');
      if (!drawer || drawer.hasAttribute('hidden')) return;
      var panel = drawer.querySelector('.cart-drawer__panel');
      if (!panel || e.button > 0 || !panel.contains(e.target)) return;
      swipe = { id: e.pointerId, x: e.clientX, y: e.clientY, panel: panel, locked: false };
    });
    document.addEventListener('pointermove', function (e) {
      if (!swipe || e.pointerId !== swipe.id) return;
      var dx = e.clientX - swipe.x;
      var dy = e.clientY - swipe.y;
      if (!swipe.locked) {
        if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
        if (dx < 10 || Math.abs(dx) <= Math.abs(dy)) { swipe = null; return; }
        swipe.locked = true;
        swipe.panel.style.transition = 'none';
      }
      if (dx > 0) swipe.panel.style.transform = 'translateX(' + dx + 'px)';
    });
    document.addEventListener('pointerup', endSwipe);
    document.addEventListener('pointercancel', endSwipe);
    function endSwipe(e) {
      if (!swipe || e.pointerId !== swipe.id) return;
      var s = swipe;
      swipe = null;
      s.panel.style.transition = '';
      s.panel.style.transform = '';
      if (s.locked && e.clientX - s.x > 80) closeCart();
    }

    /* 加购表单提交（委托，兼容编辑器重渲染） */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[data-add-to-cart]');
      var payBtn = form.querySelector('.shopify-payment-button__button');
      if (btn) btn.disabled = true;
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          return refreshCartDrawer();
        })
        .then(openCart)
        .catch(function () { form.submit(); }) /* 降级：原生提交 */
        .finally(function () {
          if (btn) btn.disabled = false;
          /* Shopify 动态结账按钮（Buy with Shop）监听表单 submit 自动进入禁用态防重复结算；
             AJAX 加购不会发生原生提交、它永远不会自行复位 —— 完成后手动恢复。 */
          if (payBtn) { payBtn.disabled = false; payBtn.removeAttribute('aria-busy'); }
        });
    });
    /* 数量调整（委托：抽屉 + 购物车页通用） */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      e.preventDefault();
      var wrap = btn.closest('[data-qty]');
      var input = wrap && wrap.querySelector('[data-qty-input]');
      if (!input) return;
      var line = btn.dataset.line; /* 购物车页行号 */
      var next = Math.max(0, parseInt(input.value, 10) + parseInt(btn.dataset.qtyChange, 10));
      input.value = next;
      if (line) {
        /* 购物车页：更新后提交表单 */
        var form = btn.closest('form');
        if (form) form.submit();
        return;
      }
      /* 抽屉：AJAX 更新 */
      var itemEl = btn.closest('[data-line]');
      var lineIdx = itemEl ? itemEl.dataset.line : null;
      if (lineIdx) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(lineIdx, 10), quantity: next })
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            return refreshCartDrawer();
          });
      }
    });
    /* 语言选择器自动提交 */
    $$('[data-locale-select]').forEach(function (sel) {
      if (sel.dataset.bound) return;
      sel.dataset.bound = '1';
      sel.addEventListener('change', function () { sel.form.submit(); });
    });
  }

  /* ---------- 客户端筛选（不写 URL，SEO 规则 7） ---------- */
  function initFilters(root) {
    var area = $('[data-collection-filters]', root);
    var grid = $('[data-product-grid]', root);
    if (!area || !grid || area.dataset.bound) return;
    area.dataset.bound = '1';
    var cards = $$('[data-product-card]', grid);
    var noResults = $('[data-no-results]', root);
    function apply() {
      var avail = $('[data-filter="availability"]', area).value;
      var tag = $('[data-filter="tag"]', area).value;
      var visible = 0;
      cards.forEach(function (c) {
        var ok = true;
        if (avail === 'true' && c.dataset.available !== 'true') ok = false;
        if (tag && (c.dataset.tags || '').indexOf(tag) === -1) ok = false;
        c.classList.toggle('hidden', !ok);
        if (ok) visible++;
      });
      if (noResults) noResults.hidden = visible > 0;
      var count = $('[data-product-count]');
      if (count) count.textContent = visible + ' / ' + cards.length;
    }
    $$('[data-filter]', area).forEach(function (sel) { sel.addEventListener('change', apply); });
    var clearBtn = $('[data-filter-clear]', area);
    if (clearBtn) clearBtn.addEventListener('click', function () {
      $$('[data-filter]', area).forEach(function (s) { s.value = ''; });
      apply();
    });
  }

  /* ---------- 邮件订阅弹窗（延迟 + localStorage 记忆） ---------- */
  function initPopup(root) {
    var popup = $('[data-email-popup]', root);
    if (!popup || popup.dataset.bound) return;
    popup.dataset.bound = '1';
    var delay = 8;
    var delayEl = popup.querySelector('[data-popup-delay]');
    try { if (localStorage.getItem('nuotie_popup_closed')) return; } catch (e) { return; }
    var delaySetting = popup.dataset.delay || delay;
    setTimeout(function () {
      popup.removeAttribute('hidden');
      popup.setAttribute('aria-hidden', 'false');
    }, parseInt(delaySetting, 10) * 1000);
    function close() {
      popup.setAttribute('hidden', '');
      try { localStorage.setItem('nuotie_popup_closed', '1'); } catch (e) {}
    }
    var c = $('[data-popup-close]', popup);
    var o = $('[data-popup-overlay]', popup);
    if (c) c.addEventListener('click', close);
    if (o) o.addEventListener('click', close);
  }

  /* ---------- 客服组件按需加载（点击悬浮球才注入 script，CWV 友好） ---------- */
  function initChat(root) {
    if (document.querySelector('[data-chat-fab]')) return;
    var url = document.body.dataset.chatUrl;
    if (!url) return;
    var fab = document.createElement('button');
    fab.className = 'chat-fab';
    fab.setAttribute('data-chat-fab', '');
    fab.setAttribute('aria-label', 'Chat');
    fab.textContent = '💬';
    fab.addEventListener('click', function () {
      if (document.querySelector('script[data-chat-loaded]')) return;
      var s = document.createElement('script');
      s.src = url;
      s.async = true;
      s.setAttribute('data-chat-loaded', '');
      document.body.appendChild(s);
    });
    document.body.appendChild(fab);
  }

  /* ---------- 统一入口（支持编辑器局部重渲染） ---------- */
  function initAll(root) {
    initMenu(root);
    initHero(root);
    initTabs(root);
    initGallery(root);
    initVariantPicker(root);
    initCart(root);
    initFilters(root);
    initPopup(root);
    initChat(root);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Shopify Theme Editor：区块局部加载/卸载（编辑器预览与前台一致） */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    var hero = $('[data-hero]', e.target);
    if (hero) initHero(e.target);
  });
})();